import CustomPageTiles from '../components/CustomPageTiles';
import Header from '../components/Header';

function CasMisc() {
  return <>
    <Header />
    
    <div id="tiles">
        <CustomPageTiles path="/cas" />
    </div>
  </>
}

export default CasMisc;
